<template>
  <v-container>
    <material-card>
      <v-layout px-3 slot="header">
        <v-flex my-4 pl-4 title align-center justify-center>Lista Partnerów</v-flex>

        <v-spacer></v-spacer>

        <v-flex>
          <v-text-field
            prepend-icon="mdi-magnify"
            name="search"
            label="Wyszukaj"
            color="white"
            clearable
            v-model="search"
          ></v-text-field>
        </v-flex>
      </v-layout>

      <v-layout text-xs-right>
        <v-flex>
          <check-permission permissions="ACCOUNT.REGISTER.PARTNER">
            <v-btn large color="error" @click="showAddModal">DODAJ PARTNERA</v-btn>
          </check-permission>
        </v-flex>
      </v-layout>

      <material-table
        editPerm="PARTNER.UPDATE"
        deletePerm="PARTNER.DELETE"
        entityType="partner"
        :headers="headers"
        :items="list"
        :actions="true"
        :search="search"
        :total-count="count"
        @pagination="reloadList"
        @edit="showEdit"
        @delete="showDeleteDialog"
      ></material-table>

      <material-dialog
        title="Potwierdź usunięcie"
        text="Czy napewno chcesz usunąć Partnera?"
        :show="!!idToDelete"
        :id="idToDelete"
        @close="hideDeleteDialog"
        @confirm="remove"
      ></material-dialog>

      <edit-modal :show="editModal" :partnerToEdit="partnerToEdit" @close="hideEditModal" @update="update"></edit-modal>
    </material-card>

    <modal :show="showModal" @close="hideModal" @save="add"></modal>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import { State, StateTranslation, address } from '@witkac/kartamiejska-shared';

import Modal from './modals/Add.modal';
import EditModal from './modals/Edit.modal';
import MaterialCard from '@/components/material/Card';
import MaterialTable from '@/components/material/Table';
import MaterialDialog from '@/components/material/Dialog';
import { listMixin } from '@/mixins/list';
import store from '@/store/store';

// @vuese
// Wyświetlanie listy Partnerów
// @group Partners
export default {
  components: {
    MaterialCard,
    MaterialTable,
    MaterialDialog,
    Modal,
    EditModal
  },
  mixins: [
    listMixin('partners', {
      added: 'Dodano Partnera.',
      addError: 'Nie udało się dodać Partnera.',
      updated: 'Zaktualizowano Partnera.',
      updateError: 'Nie udało się zaktualizować Partnera.',
      deleted: 'Usunięto Partnera.',
      deleteError: 'Nie udało się usunąć Partnera.',
      listError: 'Nie udało się pobrać listy Partnerów.'
    })
  ],
  data() {
    return {
      search: '',
      headers: [
        { text: 'Nazwa Partnera', value: 'name', link: true },
        { text: 'Status', value: 'displayState', paginationValue: 'state' },
        { text: 'Adres', sortable: false, value: 'displayAddress' },
        { text: 'Liczba usług', value: 'benefitsCount', sortable: false }
      ],
      editModal: false,
      partnerToEdit: {}
    };
  },
  methods: {
    // @vuese
    // Metoda dostosowuje listę Partnerów do prawidłowego wyświetlenia
    // @arg `partners` - tablica Partnerów
    setDisplayData(partners) {
      partners.forEach(partner => {
        this.translateState(partner);
        this.setAddress(partner);
      });
    },
    // @vuese
    // Metoda dostosowuje Partnera do prawidłowego wyświetlenia statusu
    // @arg `partner` - Partner
    translateState(partner) {
      partner.displayState = StateTranslation[State[partner.state]];
    },
    // @vuese
    // Metoda dostosowuje Partnera do prawidłowego wyświetlenia adresu
    // @arg `partner` - Partner
    setAddress(partner) {
      partner.displayAddress = address(partner);
    },
    // @vuese
    // Pobiera dane Partnera do edycji
    // @arg `id` - identyfikator Partnera
    async showEdit(id) {
      this.partnerToEdit = await this.$store.dispatch('partners/get', id);
      this.showEditModal();
    },
    // @vuese
    // Otwiera modal do edycji Partnera
    showEditModal() {
      this.editModal = true;
    },
    // @vuese
    // Ukrywa modal edycji
    hideEditModal() {
      this.editModal = false;
      this.partnerToEdit = {};
    }
  },
  watch: {
    list(array) {
      this.setDisplayData(array);
    },
    '$store.state.modalClose.confirm'(val) {
      if (val) {
        this.editModal ? this.hideEditModal() : this.hideModal();
        this.$store.dispatch('resetConfirmState');
      }
    }
  },
  beforeMount() {
    this.setDisplayData(this.list);
  }
};
</script>
